import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

export interface State {
  titleDialog:string,
  fullDialogShow:boolean,
  sidebarDialogShow:boolean,
  showDialog: boolean,
  formDialog:String,
  formSidebarDialog:String,
  options:any
}

const defaultState: State = {
  titleDialog:'',
  fullDialogShow:false,
  sidebarDialogShow:false,
  showDialog: false,
  formDialog:'NoneForm',
  formSidebarDialog:'lfs-filters-filters-index',
  options:null
}

const getters = {
  fullDialogShow: (state: State) => state.fullDialogShow,
  sidebarDialogShow: (state: State) => state.sidebarDialogShow,
  titleDialog: (state: State) => state.titleDialog,
  formDialog: (state: State) => state.formDialog,
  formSidebarDialog: (state: State) => state.formSidebarDialog
}

const mutations: MutationTree<State> = {
  SetFullDialogShow(state:State, payload:any){
    state.fullDialogShow = payload
  },
  SetSidebarDialogShow(state:State, payload:boolean){
    state.sidebarDialogShow = payload
  },
  SetTitleDialog(state:State, payload:string){
    state.titleDialog = payload
  },
  SetFormSidebarDialog(state:State, payload:string){
    state.formSidebarDialog = payload
  },
  SetFormSDialog(state:State, payload:string){
    state.formDialog = payload
  }

}

const actions: ActionTree<State, RootState> = {}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
